<div class="body" (click)="log()">

    <div class="header-wrapper">

        <div class="image-wrapper">

            <ng-container *ngIf="newsfeedNotification.performer|userImage|async; else initials">
                <img [src]="newsfeedNotification.performer|userImage|async" />
            </ng-container>

            <ng-template #initials>
                <div class="initials">
                    {{newsfeedNotification.performer|userInitials|async}}
                </div>
            </ng-template>
            
        </div>
        <div class="header-data-wrapper">
            <div class="headline">{{newsfeedNotification.performer|user|async}}: {{newsfeedNotification.observable|newsfeedObservable}}</div>
            <div class="details" [class.no-preview]="!(newsfeedNotification.identifier|newsfeedObservablePreview:newsfeedNotification.observable|async)">
                {{(newsfeedNotification.identifier|newsfeedObservablePreview:newsfeedNotification.observable|async)? (newsfeedNotification.identifier|newsfeedObservablePreview:newsfeedNotification.observable|async): 'keine Vorschau'}}
            </div>
            <div class="date">{{newsfeedNotification.fired|date:'dd.MM.yyyy HH:mm'}}</div>
        </div>

    </div>

</div>